import React from "react"
import { User } from "firebase/auth"
import { useForm } from "react-hook-form"
import { SpaceKey } from "popopo-msg"
import { api } from "../../core"

type SpaceHiddenViewerForm = {
  userId: string
}

export const SpaceHiddenViewerForm = (props: { firebase: User; spaceKey: SpaceKey }) => {
  const form = useForm<SpaceHiddenViewerForm>({
    mode: "onBlur",
    defaultValues: {
      userId: "",
    },
  })
  const { isSubmitting } = form.formState

  const onCreate = async (value: SpaceHiddenViewerForm) => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.POST("/api/v2/spaces/{space_key}/hidden_viewers/{user_id}", {
        params: { path: { space_key: props.spaceKey, user_id: value.userId } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  const onDelete = async (value: SpaceHiddenViewerForm) => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.DELETE("/api/v2/spaces/{space_key}/hidden_viewers/{user_id}", {
        params: { path: { space_key: props.spaceKey, user_id: value.userId } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <>
      <form className="d-flex flex-column gap-3 w-100">
        <div className="form-floating">
          <input className="form-control" {...form.register("userId")} disabled={isSubmitting} />
          <label>User ID</label>
        </div>

        <button type="button" className="btn btn-primary form-control" onClick={form.handleSubmit(onCreate)}>
          Add user
        </button>

        <button type="button" className="btn btn-primary form-control" onClick={form.handleSubmit(onDelete)}>
          Remove user
        </button>
      </form>
    </>
  )
}
